import * as React from 'react';

const EditIcon = ({fillColor = '#2D2756'}) => {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m7.736 2.101-4.79 5.07a1.78 1.78 0 0 0-.39.834l-.216 1.89c-.076.682.414 1.149 1.09 1.032l1.879-.32c.262-.047.63-.24.81-.438l4.79-5.07c.828-.874 1.202-1.872-.088-3.091C9.538.8 8.564 1.226 7.736 2.1Z"
        stroke={fillColor}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.936 2.945a3.574 3.574 0 0 0 3.179 3.004M1.75 12.832h10.5"
        stroke={fillColor}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
